// src/components/home/ContactSection/ContactSection.js
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faLocationDot,
    faPhone,
    faEnvelope,
    faClock,
    faDirections
} from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { trackCallClick, trackWhatsAppClick } from '../../../utils/tracking';
import './ContactSection.css';

const ContactSection = () => {
    const contactInfo = [
        {
            icon: faLocationDot,
            label: 'Address',
            value: 'Little Elly Campus, Kudlu Main Road, Bengaluru 560068'
        },
        {
            icon: faPhone,
            label: 'Phone',
            value: '+91 90198 29264',
            link: 'tel:+919019829264'
        },
        {
            icon: faEnvelope,
            label: 'Email',
            value: 'abhyaas@littleelly.com',
            link: 'mailto:abhyaas@littleelly.com'
        },
        {
            icon: faClock,
            label: 'Hours',
            value: 'Mon - Sat: 9:00 AM - 4:00 PM'
        }
    ];

    return (
        <section className="contact" id="contact">
            <div className="contact__bg">
                <div className="contact__orb"></div>
            </div>

            <div className="contact__container">
                {/* Header */}
                <div className="contact__header">
                    <span className="contact__label">Get in Touch</span>
                    <h2 className="contact__title">Contact Us</h2>
                    <p className="contact__subtitle">
                        Have questions about admissions or programs?
                        We'd love to hear from you.
                    </p>
                </div>

                {/* Content Grid */}
                <div className="contact__grid">
                    {/* Info Card */}
                    <div className="contact__info">
                        <div className="contact__info-list">
                            {contactInfo.map((item, index) => (
                                <div key={index} className="contact__info-item">
                                    <div className="contact__info-icon">
                                        <FontAwesomeIcon icon={item.icon} />
                                    </div>
                                    <div className="contact__info-content">
                                        <span className="contact__info-label">{item.label}</span>
                                        {item.link ? (
                                            <a
                                                href={item.link}
                                                className="contact__info-value contact__info-link"
                                                onClick={() => { if (item.link.startsWith('tel:')) trackCallClick({ location: 'contact_section' }); }}
                                            >
                                                {item.value}
                                            </a>
                                        ) : (
                                            <span className="contact__info-value">{item.value}</span>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Action Buttons */}
                        <div className="contact__actions">
                            <a
                                href="https://wa.me/919019829264"
                                className="contact__btn contact__btn--whatsapp"
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={() => trackWhatsAppClick({ location: 'contact_section' })}
                            >
                                <FontAwesomeIcon icon={faWhatsapp} />
                                <span>WhatsApp</span>
                            </a>
                            <a
                                href="https://maps.google.com/?q=Little+Elly+Preschool+Kudlu+Bengaluru"
                                className="contact__btn contact__btn--directions"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FontAwesomeIcon icon={faDirections} />
                                <span>Directions</span>
                            </a>
                        </div>
                    </div>

                    {/* Map */}
                    <div className="contact__map">
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.948197318714!2d77.64306211507942!3d12.890055990904486!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae1510dadb628f%3A0x200273a5760cf61f!2sLittle%20Elly%20Preschool%20Kudlu%2C%20Bengaluru%20%7C%20Nursery%20%7C%20Day%20Care%20%7C%20Kindergarten!5e0!3m2!1sen!2sin!4v1698765432100!5m2!1sen!2sin"
                            width="100%"
                            height="100%"
                            style={{ border: 0 }}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            title="Little Elly Kudlu Location"
                        ></iframe>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ContactSection;
